module.exports = "/newsfeed/components/newsfeed-description-widget-9d5da6.html";